import axios from 'axios';
const commonUrl = '/PSIGW/RESTListeningConnector/PSFT_HR/';
const instance = axios.create({
  
    //测试
    // baseURL:"http://218.104.237.43:8000/PSIGW/RESTListeningConnector/PSFT_HR",
    //正式环境
    baseURL:commonUrl,
    timeout: 50000,
    headers: {
        'Content-Type': "application/json;charset=utf-8",
        // 'Access-Control-Allow-Origin': '*'
  },
  auth: { 
	
    username: 'C_PORTAL',
		password: 'HFSelfIntfcUser0601',
	}
})


// 请求拦截(拦截器：interceptors)
instance.interceptors.request.use(config => {
    return config;
}, err => {
    return Promise.reject(err);
})

//响应拦截
instance.interceptors.response.use(result => {
    if (result.status == 200) {
        return result.data;
    }
    return result;
}, err => {
    return Promise.reject(err);
})

export default instance;